/**
 * ViewLoans Component JavaScript
 * Handles loan filtering, sorting, and dynamic interactions
 */

export function init() {
  console.log('ViewLoans component initialized');

  // Initialize filter and sort listeners
  const filterSelect = document.querySelector('select[name="filter"]');
  const sortSelect = document.querySelector('select[name="sort"]');
  const searchInput = document.querySelector('input[name="search"]');

  if (filterSelect) {
    filterSelect.addEventListener('change', handleFilter);
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', handleSort);
  }

  if (searchInput) {
    searchInput.addEventListener('input', handleSearch);
  }

  // Add button event listeners
  const deleteButtons = document.querySelectorAll('[data-action="delete"]');
  deleteButtons.forEach(btn => {
    btn.addEventListener('click', handleDeleteLoan);
  });
}

/**
 * Handle loan filter changes
 */
function handleFilter(e) {
  const filterValue = e.target.value;
  const loanItems = document.querySelectorAll('.loan-item');
  const emptyState = document.getElementById('empty-state');

  let visibleCount = 0;

  loanItems.forEach(item => {
    const status = item.getAttribute('data-status');

    if (filterValue === 'all' || status === filterValue) {
      item.style.display = 'block';
      visibleCount++;
    } else {
      item.style.display = 'none';
    }
  });

  // Show/hide empty state
  if (visibleCount === 0) {
    emptyState?.classList.remove('hidden');
  } else {
    emptyState?.classList.add('hidden');
  }
}

/**
 * Handle loan sort changes
 */
function handleSort(e) {
  const sortValue = e.target.value;
  const container = document.getElementById('loans-container');
  const loanItems = Array.from(document.querySelectorAll('.loan-item'));

  loanItems.sort((a, b) => {
    const aValue = a.getAttribute(`data-${sortValue}`);
    const bValue = b.getAttribute(`data-${sortValue}`);

    if (sortValue === 'due_date' || sortValue === 'amount') {
      return parseFloat(bValue) - parseFloat(aValue);
    }

    return aValue.localeCompare(bValue);
  });

  container?.replaceChildren(...loanItems);
}

/**
 * Handle loan search
 */
function handleSearch(e) {
  const searchTerm = e.target.value.toLowerCase();
  const loanItems = document.querySelectorAll('.loan-item');
  const emptyState = document.getElementById('empty-state');

  let visibleCount = 0;

  loanItems.forEach(item => {
    const loanName = item.getAttribute('data-loan-name')?.toLowerCase() || '';

    if (loanName.includes(searchTerm)) {
      item.style.display = 'block';
      visibleCount++;
    } else {
      item.style.display = 'none';
    }
  });

  // Show/hide empty state
  if (visibleCount === 0) {
    emptyState?.classList.remove('hidden');
  } else {
    emptyState?.classList.add('hidden');
  }
}

/**
 * Handle delete loan (via HTMX or direct)
 */
function handleDeleteLoan(e) {
  if (confirm('Are you sure you want to delete this loan?')) {
    const loanId = e.target.getAttribute('data-loan-id');
    // TODO: Implement delete via HTMX or direct API call
    console.log('Delete loan:', loanId);
  }
}
